import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-autopilot",
  "use": "icon-soc-l1-autopilot-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-l1-autopilot\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\">\r\n  <path d=\"M160 640h704v64H160v-64z\" />\r\n  <path d=\"M192 480l128-160h384l128 160H192zm96 0h448l-64-96H352l-64 96z\" />\r\n  <path d=\"M704 192v320l-128-64 128-64V192h64v448h-64V192z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-autopilot.svg
// module id = se/O
// module chunks = 488